module.exports = __webpack_public_path__ + "img/card6.39af1999.jpg";